import React from "react";
import { Link } from "react-router-dom";
import LoomsIcon from "../Components/Icons/LoomsIcon";
import { useKT } from "../../pages/karkhana/i18n/kt";
import { KP } from "../../pages/karkhana/karkhanaPaths";
import { useCashbookStatus } from "../../helpers/cashbookStatus";

const svg = (children: React.ReactNode) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {children}
  </svg>
);

/**
 * The only menu a Karkhana Supervisor sees, the same five places as Karkhana's tab bar: home (the
 * loom board), daily work, attendance, pay and more (cash book, what's waiting, pay sheets, sarees).
 * With the Cash book add-on: daily work, attendance, pay, cash (नकद) and more; home moves into More.
 */
const SupervisorMenu = ({ location, expanded }: { location: any; expanded: boolean }) => {
  const { t } = useKT();
  const path: string = location?.pathname || "";
  const item = (to: string, label: string, icon: React.ReactNode, on: boolean) => (
    <Link to={to} key={to} data-tip={t(label)} aria-label={t(label)}>
      <div className={on ? "verticleNameP verticleNamePOnclick" : "verticleNameP"}>
        {icon}
        {expanded ? <span className="verticleName">{t(label)}</span> : null}
      </div>
    </Link>
  );
  const home = path === KP.home || path === `${KP.home}/`;
  const work = path.startsWith(KP.dailyWork) || path.startsWith(KP.rounds);
  const att = path.startsWith(KP.attendance) || path.startsWith(KP.jobWork);
  const cashbook = useCashbookStatus();
  const cashOn = cashbook.loaded && cashbook.enabled;
  const cash = cashOn && path.startsWith(KP.cashBook);
  const pay = path.startsWith(KP.pay) || (!cashOn && path.startsWith(KP.cashBook));
  return (
    <>
      {cashOn ? null : item(KP.home, "Home", svg(<path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" />), home)}
      {item(KP.dailyWork, "Daily work", <LoomsIcon />, work)}
      {item(
        KP.attendance,
        "Attendance",
        svg(
          <>
            <circle cx="12" cy="8" r="3.5" />
            <path d="M5 19.5c1.2-3.3 3.9-5 7-5s5.8 1.7 7 5" />
          </>
        ),
        att
      )}
      {item(
        KP.pay,
        "Pay",
        svg(
          <>
            <rect x="3" y="6" width="18" height="12" rx="2.5" />
            <circle cx="12" cy="12" r="2.6" />
          </>
        ),
        pay
      )}
      {cashOn
        ? item(
            KP.cashBook,
            "Cash",
            svg(
              <>
                <rect x="2.5" y="8" width="17" height="11" rx="1.8" />
                <path d="M5 5.5h15.5a1 1 0 0 1 1 1V16" />
                <path d="M8.5 11.2h5M8.5 13.4h5M10.2 11.2c1.9 0 1.9 2.2 0 2.2l3 3" />
              </>
            ),
            cash
          )
        : null}
      {item(
        KP.more,
        "More",
        svg(
          <>
            <circle cx="5" cy="12" r="1.6" />
            <circle cx="12" cy="12" r="1.6" />
            <circle cx="19" cy="12" r="1.6" />
          </>
        ),
        (cashOn || !home) && !work && !att && !pay && !cash && path.startsWith(KP.home)
      )}
    </>
  );
};

export default SupervisorMenu;
